import { render, staticRenderFns } from "./CancellationSurvey.vue?vue&type=template&id=40862620&scoped=true&"
import script from "./CancellationSurvey.vue?vue&type=script&lang=ts&"
export * from "./CancellationSurvey.vue?vue&type=script&lang=ts&"
import style0 from "./CancellationSurvey.vue?vue&type=style&index=0&id=40862620&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40862620",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VRow,VSpacer})
